import { type DocumentType, graphql } from '@generated/gql';

export const SEARCH_ORGANIZATIONS = graphql(/** GraphQL */ `
    query organizationSwitcherSearchOrganizations($input: FetchOrganizationsInput!) {
        fetchOrganizations(input: $input) {
            organizations {
                id
                translatedName { 
                    ...OrganizationTranslatedString
                }
                parents {
                    id
                    translatedName { 
                        ...OrganizationTranslatedString
                    }
                }
            }
        }
    }
`);

export const FETCH_INITIAL_ORGANIZATIONS = graphql(/** GraphQL */ `
    query organizationSwitcherFetchInitialOrganizations($organizationId: String!) {
        fetchOrganization(organizationId: $organizationId) {
            organization {
                id
                translatedName { 
                    ...OrganizationTranslatedString
                }
                parents {
                    id
                    translatedName { 
                        ...OrganizationTranslatedString
                    }
                    parent {
                        id
                    }
                    children {
                        id
                        translatedName { 
                            ...OrganizationTranslatedString
                        }
                        children {
                            id
                        }
                    }
                }
            }
        }
    }
`);

export const FETCH_CHILD_ORGANIZATIONS = graphql(/** GraphQL */ `
    query organizationSwitcherFetchChildOrganizations($organizationId: String!) {
        fetchOrganization(organizationId: $organizationId) {
            organization {
                id
                children {
                    id
                    translatedName { 
                        ...OrganizationTranslatedString
                    }
                    children {
                        id
                    }
                }
            }
        }
    }
`);

export type OrganizationSwitcherParent = DocumentType<
  typeof FETCH_INITIAL_ORGANIZATIONS
>['fetchOrganization']['organization']['parents'][number];

export type OrganizationSwitcherFetchedChild = DocumentType<
  typeof FETCH_CHILD_ORGANIZATIONS
>['fetchOrganization']['organization']['children'][number];

export type OrganizationTreeNode = Pick<
  OrganizationSwitcherFetchedChild,
  'id' | 'translatedName'
> & {
  open?: boolean;
  children?: OrganizationTreeNode[];
};
